// extracted by mini-css-extract-plugin
export var desc = "index-module--desc--mMyEb";
export var downloadCardWrapper = "index-module--downloadCardWrapper--TjHwx";
export var leftContent = "index-module--leftContent--ZoK2P";
export var linkText = "index-module--linkText--5TUOQ";
export var rightContent = "index-module--rightContent--F3ziy";
export var title = "index-module--title--4AzW+";